import type { SVGProps } from 'react'

export const MydraIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_285_634)">
      <path
        d="M10.0125 13.9798L10.6541 13.181C13.0681 14.6538 16.0637 14.3836 17.8823 12.1199C19.858 9.66074 19.077 6.54817 16.6178 4.57236L10.6718 -0.201614L7.62508 3.59182L8.9819 4.06048L8.35114 4.84648C5.93717 3.37371 2.9337 3.65372 1.11511 5.91741C-0.860671 8.37661 -0.0717323 11.4793 2.38744 13.4552L8.2971 18.2016L11.3359 14.417L10.0115 13.9798H10.0125ZM6.73691 6.79281C7.96306 5.26601 10.1963 5.02235 11.723 6.24851C13.2498 7.47467 13.4935 9.70691 12.2673 11.2347C11.0412 12.7615 8.808 13.0052 7.28121 11.779C5.75442 10.5528 5.51077 8.31962 6.73691 6.79281Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_285_634">
        <rect width="19" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
